import { render } from "./PaymentDetail.vue?vue&type=template&id=396b2740&scoped=true"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"

import "./PaymentDetail.vue?vue&type=style&index=0&id=396b2740&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396b2740"]])

export default __exports__